import {lazy} from './lang.js';

export const add = (...operands) => {
    return (...args) => {
        return operands.reduce((sum, x) => lazy(x, ...args) + sum, 0);
    };
};

export const multiply = (...operands) => {
    return (...args) => {
        return operands.reduce((sum, x) => lazy(x, ...args) * sum, 1);
    };
};

export const mod = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ... args);
        let _b = lazy(b, ... args);
        return ((_a%_b)+_b)%_b;
    };
};

